import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Teaser Sidebar Icon",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-teaser-sidebar-icon",
    args: {
        contentElement: "false",
    },
    argTypes: {
        contentElement: {
            control: "boolean",
        },
    },
};

const Template = ({ contentElement }) => html`
    <ux-iws-teaser-sidebar-icon content-element="${contentElement}">
        <ux-icon name="globe" slot="icon"></ux-icon>
        <span slot="title" class="ux-text-normal">
            Finanzierung
        </span>
        <a href="#" class="ux-text-link ux-text-link--green" slot="link">
            Discover more
            <ux-icon name="arrow-small-right"></ux-icon>
        </a>
    </ux-iws-teaser-sidebar-icon>
`;

export const Default = Template.bind({});
